import { render, staticRenderFns } from "./AddCalendarioMidiaSociais.vue?vue&type=template&id=dbe44676"
import script from "./AddCalendarioMidiaSociais.vue?vue&type=script&lang=js"
export * from "./AddCalendarioMidiaSociais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports